import React from "react";
import styled from "@emotion/styled";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { purple, green, blue } from "@mui/material/colors";
import Footer from "../Footer";
import Navbar from "components/navbar/Navbar";
// Define custom theme

const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
    },
    secondary: {
      main: green[500],
    },
    background: {
      default: "#F5F5F7",
    },
  },
  background: "#ffff",
  typography: {
    fontFamily: "Arial, sans-serif",
  },

  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {
            color: "#0E2B63",
          },
          "& label.Mui-focused": {
            color: "#0E2B63",
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: "#0E2B63",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#0E2B63",
            },
            "&:hover fieldset": {
              borderColor: "#0E2B63",
              borderWidth: "0.15rem",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#0E2B63",
            },
          },
          "&.Mui-disabled": {
            backgroundColor: "#F5F5F7", // Change background to pink when disabled
            color: "#191E31",
            "& fieldset": {
              borderColor: "#0E2B63",
              color: "#191E31",
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#0E2B63",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0E2B63",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0E2B63",
          },
          "&.Mui-disabled": {
            backgroundColor: "#F5F5F7",
            fontWeight: "600",
            borderColor: "#0E2B63", // Adjust the border color if needed for disabled state
            "& fieldset": {
              borderColor: "#0E2B63", // Adjust the border color if needed for disabled state
              fontWeight: "600",
            },
          },
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.MuiOutlinedInput-root": {
            backgroundColor: "#ffff",
            borderRadius: "0.625rem",
          },
        },
        input: {
          "&.Mui-disabled": {
            WebkitTextFillColor: "#191E31",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        "& .MuiSwitch-switchBase.Mui-checked": {
          color: "#000243",
          "&:hover": {
            backgroundColor: "#000243",
          },
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: "#000243",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#737D86",
          fontWeight: 500,
          fontFamily: "Montserrat",
          "& .MuiInputLabel-asterisk": {
            color: "red !important",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          marginLeft: "10px",
          fontWeight: 600,
          color: "#191E31",
        },
      },
    },
  },
});
const LayoutAccessManagement = ({ title, children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Navbar title={"Access Management"} />
        <Content>{children}</Content>
        {/* <Footer /> */}
      </Container>
    </ThemeProvider>
  );
};
const Container = styled.div`
  position: relative;
  min-height: calc(100vh - 64px);
  background: ${(props) =>
    props.theme.palette.background.default}; // Use theme background color
`;
const Content = styled.div`
  margin-top: 4rem;
  padding: 32px 25px 0px 25px;
  background: ${(props) =>
    props.theme.palette.background.default}; // Use theme background color
`;
export default LayoutAccessManagement;
